// src/app/core/constants/progress-steps.constants.ts
export const PROGRESS_STEPS = {

  // === REGISTRO ===
  SIGNUP_STARTED: 'signup_started', // ← Estado inicial do cadastro
  TERMS_VIEWED: 'terms_viewed',
  TERMS_ACCEPTED: 'terms_accepted',
  TERMS_ABANDONED: 'terms_abandoned',

  // === DADOS DO USUÁRIO ===
  USER_DATA_VIEWED: 'user_data_viewed',
  USER_DATA_COMPLETED: 'user_data_completed',
  USER_DATA_ABANDONED: 'user_data_abandoned',

  // === CONFIRMAÇÃO DE EMAIL ===
  EMAIL_CONFIRMATION_VIEWED: 'email_confirmation_viewed',
  EMAIL_SENT: 'email_sent',         // ← Primeiro envio do e-mail de confirmação
  EMAIL_RESENT: 'email_resent',     // ← Apenas para reenvio manual
  EMAIL_CONFIRMED: 'email_confirmed',
  EMAIL_CONFIRMATION_ABANDONED: 'email_confirmation_abandoned',

  // === ASSINATURA ===
  // =====================================================
  // FLUXO PRINCIPAL (UI / APP STATE)
  // Estados de Jornada (client-driven)
  // =====================================================
  SUBSCRIPTION_STARTED: 'subscription_started',

  // Falha de pagamento (simulação atual ou Stripe futuro)
  SUBSCRIPTION_PAYMENT_FAILED: 'subscription_payment_failed',

  // Assinatura concluída com sucesso
  SUBSCRIPTION_COMPLETED: 'subscription_completed',

  // =====================================================
  // INFRA ESTRUTURA (PAGAMENTO)
  // Estados técnicos (backend-driven)
  // =====================================================

  /**
   * SUBSCRIPTION_ABANDONED
   * -----------------------------------------------------
   * Usuário saiu do fluxo antes de concluir.
   * Estado reservado para uso backend (webhooks Stripe).
   * NÃO deve ser utilizado para controle de fluxo no client.
   */
  SUBSCRIPTION_ABANDONED: 'subscription_abandoned',

  /**
   * ETAPAS DE CHECKOUT (COMPATÍVEL COM STRIPE FUTURO)
   * Representam o fluxo de pagamento, independentemente do
   * provider (Stripe ou simulação).
   * São micro-estados técnicos, não estados de jornada.
   */
  SUBSCRIPTION_CHECKOUT_CREATED: 'subscription_checkout_created',
  SUBSCRIPTION_CHECKOUT_REDIRECTED: 'subscription_checkout_redirected',
  SUBSCRIPTION_PAYMENT_PROCESSING: 'subscription_payment_processing',

  // === AVALIAÇÃO ===

  /* Questionário */
  QUESTIONNAIRE_STARTED: 'questionnaire_started',
  QUESTIONNAIRE_COMPLETED: 'questionnaire_completed',

  /* Análise Fotográfica */
  PHOTO_ANALYSIS_STARTED: 'photo_analysis_started',
  PHOTO_ANALYSIS_COMPLETED: 'photo_analysis_completed',

  /* Perguntas complementares */
  ADDITIONAL_QUESTION_STARTED: 'additional_question_started',

  /* Avaliação concluída */
  EVALUATION_COMPLETED: 'evaluation_completed',

  // === TREINAMENTO ===
  TRAINING_STARTED: 'training_started',
  TRAINING_COMPLETED: 'training_completed',

} as const;

export type LastStep =
  | typeof PROGRESS_STEPS[keyof typeof PROGRESS_STEPS]
  | `workout_${number}_exercise_${number}`
  | null;

// Tipo derivado automaticamente
export type ProgressStepKey = keyof typeof PROGRESS_STEPS;
export type ProgressStepValue = (typeof PROGRESS_STEPS)[ProgressStepKey];
